<div class="pre-setting-btn">
   <button id="preSettingsBtn" class="setting ng-binding" [ngClass]="{'chromeClient': isChromeClient}"
      title="{{advancedButtonTitle}}" (click)="showPreSetting()" (mousedown)="autoBlur($event)" tabindex="0" name="{{advancedButtonName}}" role="button"
      type="button" [hidden]="hideUI" [autoFocus] aria-haspopup="true"></button>
</div>